import React from 'react';
import QuoteApp from './QuoteApp';
import './index.css'
const App = () => {
    return (
        <div id="appContainer">
            <QuoteApp />
        </div>
    );
};

export default App;